module.exports = __webpack_public_path__ + "static/media/A-2-Ring-Doorbell.97570137.svg";